__turbopack_context__.v({
  "image": "agentAvatar-module__Rel28W__image",
  "root": "agentAvatar-module__Rel28W__root",
});
